<template>
  <b-modal id="customer-show-document" ref="modal" :title="dialog_title" hide-footer>
    <div class="row form-group">
      <div class="col-sm-12">
        <customer-search id="show_document_customer" ref="search" :locked="locked" @customerSelected="customerSelected"
          @customerDeselected="customerDeselected"></customer-search>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-3">
        <select v-model="type" @change="template_id = null" id="show_document_type" class="custom-select form-control"
          :disabled="is_editing">
          <option value="consent">Consentimiento</option>
          <option value="proof">Justificante</option>
          <option value="report">Informe</option>
          <option value="prescription">Receta</option>
          <option value="document">Archivo</option>
        </select>
        <label for="show_document_type" class="wabident-info">Tipo de Documento</label>
      </div>
      <div class="col-sm-4" v-if="is_templatable">
        <v-select v-model="selected_template" :disabled="is_editing" class="wabident-vselect"
          id="show_document_template" :options="template_options"></v-select>
        <label for="show_document_template" class="wabident-info">Plantilla</label>
      </div>
      <div class="col-sm-3">
        <input class="form-control" type="date" id="show_document_date" v-model="created_at" />
        <label for="show_document_date" class="wabident-info">Fecha</label>
      </div>
      <div class="col-sm-2">
        <input class="form-control" type="time" id="show_document_hour" v-model="hour" />
        <label for="show_document_hour" class="wabident-info">Hora</label>
      </div>
    </div>

    <div class="row form-group">

      <div class="col-sm-3">
        <select v-model="doctor_id" id="show_document_doctor" class="custom-select form-control"
          :disabled="lock_doctor">
          <option :value="null">Selecciona Doctor/a</option>
          <option v-for="(doctor, index) in doctors" :key="index" :value="doctor.doctor.id">
            {{ doctor.name }}
          </option>
        </select>
        <label for="show_document_doctor" class="wabident-info">Doctor principal (obligatorio)</label>
      </div>


      <div class="col-sm-3">
        <select v-model="second_doctor_id" id="show_document_second_doctor" class="custom-select form-control">
          <option :value="null">Selecciona Adjunto/a</option>
          <option v-for="(doctor, index) in doctors" :key="index" :value="doctor.doctor.id">
            {{ doctor.name }}
          </option>
        </select>
        <label for="show_document_second_doctor" class="wabident-info">Personal adjunto (opcional)</label>
      </div>



      <div class="col">
        <input id="show_document_title" type="text" class="form-control" v-model="title" />
        <label for="show_document_title" class="wabident-info">Cabecera del documento</label>
      </div>

      <div v-if="is_revokable" class="col-sm-3">
        <input type="date" v-model="revoke_date" id="show_document_revoke_date" class="form-control" />
        <label for="show_document_revoke_date" class="wabident-info">Fecha de Revocación</label>
      </div>
    </div>

    <div class="row form-group">
      <div v-if="is_downloadable" class="col">
        <div class="mb-2" v-if="is_uploaded">
          Archivo subido
          <a class="btn-link" :href="file_link">{{ document.file_name }}</a>
        </div>

        <b-form-file v-model="file" :state="Boolean(file)" :placeholder="file_placeholder" class="wabident-file-input"
          :required="!is_editing" :disabled="is_loading"></b-form-file>
      </div>
      <div v-else-if="!template_id" class="col">
        <quill-editor id="show_document_content" :options="options" v-model="content"></quill-editor>
        <label for="show_document_content" class="wabident-info">Texto del documento</label>
      </div>
    </div>

    <div class="form-group row" v-if="!embed">
      <div class="col-sm-6">
        <select v-model="appointment_id" id="show_document_appointment" class="custom-select form-control">
          <option value="null">Selecciona cita &hellip;</option>
          <option :value="app.id" :key="app.id" v-for="app in appointments">
            {{ appName(app) }}
          </option>
        </select>
        <label for="show_document_appointment" class="wabident-info">Cita asociada al documento</label>
      </div>
      <div class="col-sm-6">
        <select v-model="history_entry_id" id="show_document_entry" class="custom-select form-control">
          <option :value="null">Selecciona historia &hellip;</option>
          <option :value="his.id" :key="his.id" v-for="his in history_entries">
            {{ historyName(his) }}
          </option>
        </select>
        <label for="show_document_entry" class="wabident-info">Historia asociada al documento</label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col text-center">
        <button :disabled="is_loading" @click="onDelete" v-show="is_editing" class="btn btn-wabident-delete float-left"
          style="width: 53.6px; height: 53.6px"></button>

        <button @click="submitDocument" class="btn btn-primary btn-wabident vertical-align-middle"
          :disabled="!is_valid || is_loading">
          <span v-if="is_loading">
            Guardando
            <i class="fas fa-spin fa-circle-notch"></i>
          </span>
          <span v-else-if="is_editing">Modificar Documento</span>
          <span v-else>Guardar Documento</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BIconFileEarmarkPerson } from 'bootstrap-vue';

export default {
  props: {
    locked: { default: true },
    embed: { default: false }
  },
  data() {
    return {
      lock_doctor: false,
      is_loading: false,
      is_editing: false,
      document: null,
      hour: null,
      selected_customer: null,
      created_at: new Date().toISODate(),
      revoke_date: "",
      doctor_id: null,
      second_doctor_id: null,
      selected_template: null,
      title: "",
      content: "",
      type: "consent",
      file: null,
      templates: [],
      appointment_id: null,
      history_entry_id: null,
      appointments: [],
      history_entries: [],
      clinics: [],
      options: {
        placeholder: "Introduce texto ...",
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ align: [] }, { list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            ["blockquote", "code-block", "link"],
            ["clean"],
          ],
        },
      },
    };
  },
  watch: {
    type(val) {
      this.getTemplates();
    },
    selected_template(val) {
      if (val && val.template) {
        this.title = val.template.title;
        this.content = val.template.content;
      }
    }
  },
  computed: {
    template_id() {
      if (this.selected_template) {
        return this.selected_template.template.id;
      }
      return null;
    },
    template_options() {
      return this.templates.map((t) => {
        return {
          label: t.title,
          value: t.id,
          template: t,
        }
      });
    },
    is_valid() {
      if (this.is_loading) return false;
      if (!this.doctor_id) return false;
      if (!this.title) return false;
      if (!this.hour) return false;
      if (!this.type) return false;
      if (this.type == "document" && !this.file) return false;
      return true;
    },
    is_downloadable() {
      return this.type && this.type == "document";
    },
    is_templatable() {
      return (
        this.type && this.type !== "document" && this.type !== "prescription"
      );
    },
    is_uploaded() {
      return (
        this.is_editing &&
        this.is_downloadable &&
        this.document &&
        this.document.file_name &&
        this.document.file_name != ""
      );
    },
    file_link() {
      if (!this.is_uploaded) return "";
      return `/customer/${this.selected_customer.id}/document/${this.document.id}/download?action=download`;
    },
    file_placeholder() {
      if (this.is_uploaded) return "Elige un nuevo archivo para subir";

      return "Elige un archivo";
    },
    doctors() {
      if (!this.clinic) return [];
      return this.clinic.doctors.filter((d) => {
        return d.is_active || this.doctor_id == d.doctor.id || this.second_doctor_id == d.doctor.id;
      });
    },
    dialog_title() {
      return this.is_editing ? "Editar Documento" : "Crear Documento";
    },
    is_revokable() {
      return this.is_editing && this.type == "consent";
    },
    day_slots() {
      if (!this.clinic) return [];
      return this.clinic.schedule.daily_timeslots[this.dayindex];
    },
    dayindex() {
      let d = moment(this.created_at).toDate().getDay();
      if (d == 0) return 6;
      return d - 1;
    },
    ...mapGetters(["msgwindow", "errorwindow", "clinic"]),
  },
  methods: {
    stripHtml(html) {
      let tmp = document.createElement("div");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
    appName(app) {
      return moment(app.date_from).format('DD/MM/YY - HH:mm') + ' - ' + app.notes;
    },
    historyName(h) {
      return moment(h.created_at).format('DD/MM/YY') + ' - ' + this.stripHtml(h.notes);
    },
    updateAppointments(customer) {
      this.appointments = [];
      this.history_entries = [];
      this.clinics = [];

      axios.get(`/customer/${customer.id}/appointments`).then((response) => {
        this.appointments = response.data.appointments;
        this.clinics = response.data.clinics;
      });

      axios.get(`/customer/${customer.id}/history_entries`).then((response) => {
        this.history_entries = response.data;
      });
    },
    customerSelected(customer) {
      if (customer) {
        this.selected_customer = customer;
      }
    },
    customerDeselected() {
      this.selected_customer = null;
    },
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    showNew(customer, appointment_id = null, history_entry_id = null, doctor_id = null) {
      this.is_editing = false;
      this.document = null;
      this.type = "consent";
      this.created_at = new Date().toISODate();
      this.doctor_id = doctor_id;
      this.lock_doctor = (doctor_id !== null)
      this.second_doctor_id = null;
      this.title = "";
      this.content = "";
      this.revoke_date = "";
      this.selected_template = null;
      this.hour = moment().format('HH:mm');
      this.appointment_id = appointment_id;
      this.history_entry_id = history_entry_id;

      this.selected_customer = customer;
      setTimeout(() => {
        this.$refs.search.select(customer);
      }, 100);

      this.updateAppointments(customer);
      this.getTemplates();
      this.show();
      setTimeout(() => {
        this.getConsentDocumentStatus();
      }, 200);
    },
    showEdit(customer, document) {
      this.is_editing = true;
      this.document = document;
      this.selected_customer = customer;
      this.lock_doctor = false;
      this.type = document.type;
      this.created_at = moment(document.created_at).toDate().toISODate();
      this.doctor_id = document.doctor_id;
      this.second_doctor_id = document.second_doctor_id;
      this.title = document.title;
      this.content = document.content;

      this.hour = this.getHour(document.created_at);
      this.appointment_id = document.appointment_id;
      this.history_entry_id = document.history_entry_id;

      if (document.revoke_date && document.revoke_date != "") {
        this.revoke_date = moment(document.revoke_date).toDate().toISODate();
      } else {
        this.revoke_date = "";
      }

      setTimeout(() => {
        this.$refs.search.select(customer);
      }, 100);

      this.updateAppointments(customer);
      this.getTemplates(document.template_id);
      this.show();
    },
    getFirstHour() {
      return this.day_slots.morning.start[0];
    },
    getHour(date) {
      return moment(date).format("HH:mm");
    },
    getFormData() {
      let ret = new FormData();

      ret.append("created_at", this.created_at);
      ret.append("doctor_id", this.doctor_id);
      ret.append("customer_id", this.selected_customer.id);
      ret.append("title", this.title);
      ret.append("content", this.content);
      ret.append("type", this.type);
      ret.append("revoke_date", this.revoke_date);
      ret.append("template_id", this.template_id);
      ret.append("hour", this.hour);

      if (this.second_doctor_id) {
        ret.append("second_doctor_id", this.second_doctor_id);
      }

      if (this.appointment_id) {
        ret.append("appointment_id", this.appointment_id);
      }

      if (this.history_entry_id) {
        ret.append("history_entry_id", this.history_entry_id);
      }

      if (this.clinic) {
        ret.append("clinic_id", this.clinic.id);
      }

      if (this.type == "document") {
        ret.append("file", this.file);
      }

      return ret;
    },
    checkEmpty(value) {
      return (!value || value == '' || value == null);
    },
    getConsentDocumentStatus() {
      if (this.type !== 'consent') {
        return true;
      }



      let errors = [];

      if (this.checkEmpty(this.selected_customer.full_name)) {
        errors.push('Nombre completo');
      }

      if (this.checkEmpty(this.selected_customer.nif)) {
        errors.push('DNI/NIF/NIE');
      }

      if (this.checkEmpty(this.selected_customer.birth_date)) {
        errors.push('Fecha de nacimiento');
      }

      if (errors.length > 0) {
        console.log(errors);
        let msg = 'Para poder emitir consentimientos se deben rellenar los siguientes campos de la Ficha de Paciente:  <strong>' + errors.join(', ') + '</strong>';
        this.errorwindow.show('Error', msg);
        return false;
      }

      return true;
    },
    submitDocument() {
      if (!this.getConsentDocumentStatus()) {
        return;
      }

      if (this.is_editing) {
        this.editDocument();
      } else {
        this.createDocument();
      }
    },
    createDocument() {
      if (!this.is_loading) {
        this.is_loading = true;
        let formData = this.getFormData();
        axios
          .post("/document", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            this.msgwindow.success("Documento creado con éxito");
            this.$emit("submit", response.data);
            this.$emit("add", response.data);
            this.hide();
          })
          .catch((err) => {
            console.log("[ERR] createDocument", err);
            this.errorwindow.show("Error", "Error creando documento");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    editDocument() {
      if (!this.is_loading) {
        this.is_loading = true;
        let formData = this.getFormData();
        axios
          .post(`/document/${this.document.id}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            this.msgwindow.success("Documento modificado con éxito");
            this.$emit("submit", response.data);
            this.$emit("edit", response.data);
            this.hide();
          })
          .catch((err) => {
            console.log("[ERR] editDocument", err);
            this.errorwindow.show("Error", "Error edidanto documento");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    getTemplates(selected_template_id) {
      axios
        .get("/document_templates", {
          params: {
            type: this.type,
          },
        })
        .then((resp) => {
          this.templates = resp.data;
          if (selected_template_id) {
            this.templates.forEach((t) => {
              if (t.id == selected_template_id) {
                this.selected_template = {
                  label: t.title,
                  value: t.id,
                  template: t,
                }
              }
            });
          }
        })
        .catch((err) => {
          this.templates = [];
          this.msgwindow.error("Error cargando plantillas de documento");
        });
    },
    onDelete() {
      this.errorwindow.show(
        "Confirmación",
        "¿Desea borrar el documento?",
        "Borrar",
        "Cancelar",
        () => {
          if (!this.is_loading) {
            this.is_loading = true;
            axios
              .post(`/document/${this.document.id}`, { _method: "delete" })
              .then((resp) => {
                this.msgwindow.success("Documento borrado con éxito");
                this.$emit("submit");
                this.hide();
              })
              .catch((err) => {
                console.log("[ERR] deleteDocument", err);
                this.errorwindow.show("Error", "Error borrando el documento");
              })
              .then(() => {
                this.is_loading = false;
              });
          }
        }
      );
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss">
#customer-show-document {
  .modal-dialog {
    max-width: 50vw;
  }

  #show_document_content .ql-container {
    height: 250px;
    overflow-y: scroll;
  }
}
</style>
